export const ADVISOR_CATEGORIES = [
  "Affinity Group",
  "Association",
  "Bank",
  "Credit Union",
  "IMO - Life",
  "IMO - P&C",
  "Integration Partner - Employee Benefits",
  "Integration Partner - Financial Services",
  "Integration Partner - P&C",
  "Lender",
  "Multi Credit Union CUSO",
  "Organization with over 5,000 accounts"
];
